import { createFileRoute } from '@tanstack/react-router';
import { EuModule } from '@/mobile/modulos/eu/EuModule';

export const Route = createFileRoute('/m/eu')({
  component: EuModule,
});
